/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Data Imports */

import { Typography } from "@material-ui/core";
import AppConfig from "../../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  iconImage: {
    height: 38,
    width: 38,
  },
  iconTextRow: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flex: 1,
    background: "#ffffff",
    gap: "1rem",
    height: "126px",
    padding: "1rem 1rem 1rem 1rem",
    boxShadow: "0px 4px 18px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "1rem",
    border: "1px solid  rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("xs")]: {
      gap: "1.25rem",
    },
  },
  reraContainer: {
    margin: "0rem 2rem 1rem 2rem",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignItems: "space-between",
    justifyContent: "flex-start",
  },
  heading: {
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    color: "#666666",
    width: "100%",
  },
  subHeading: {
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#666666",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      wordBreak: "break-word",
    },
  },
  maincontainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    margin: "2rem 0rem 2rem 0rem",
    padding: "0rem 2rem 0rem 2rem",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  iconTextCard: {
    width: "45%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

const ProjectDeatilsMobileCard = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className={classes.maincontainer}>
          <div className={`${classes.iconTextRow} ${props.className}`}>
            <img
              alt={AppConfig.imageAltText}
              loading="lazy"
              referrerPolicy="no-referrer"
              height={40}
              width={40}
              src={"/images/icons/heavie/singleproperty/land_area.svg"}
              className={classes.iconImage}
            />

            <Typography
              variant="body2"
              component="span"
              className={classes.heading}
            >
              12,150 Sqft Land area
            </Typography>
          </div>
          <div className={`${classes.iconTextRow} ${props.className}`}>
            <img
              alt={AppConfig.imageAltText}
              loading="lazy"
              referrerPolicy="no-referrer"
              height={40}
              width={40}
              src={"/images/icons/heavie/singleproperty/project_approval.svg"}
              className={classes.iconImage}
            />

            <Typography
              variant="body2"
              component="span"
              className={classes.heading}
            >
              BBMP Approved
            </Typography>
          </div>
          {/* <div className={`${classes.iconTextRow} ${props.className}`}>
        <img
          alt={AppConfig.imageAltText}
          loading="lazy"
          referrerPolicy="no-referrer"
          height={40}
          width={40}
          src={"/images/icons/heavie/singleproperty/building.svg"}
           className={classes.iconImage}
        />

          <Typography
            variant="body2"
            component="span"
            className={classes.heading}
          >
28 Units
          </Typography>
              </div> */}
        </div>
        <div className={`${classes.iconTextRow} ${classes.reraContainer} ${props.className}`}>
          <img
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            height={38}
            width={38}
            src={"/images/icons/heavie/singleproperty/rera.svg"}
            className={classes.iconImage}
          />
          <div
            className={classes.text}
            style={{ gap: "0.5rem" }}
          >
            <Typography
              variant="body2"
              component="span"
              className={classes.heading}
            >
              {"RERA No"}
            </Typography>
            <Typography
              variant="body2"
              component="span"
              className={classes.subHeading}
            >
              {"PRM/KA/RERA/1251/446/PR/210222/004725"}
            </Typography>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProjectDeatilsMobileCard;
